const isPlural = (entity, result = 's') => (entity === 1 ? '' : result)

const handleActivity = ({ dateTo, dateFrom = Date.now() }) => {
  const date1 = new Date(dateTo)
  const date2 = new Date(dateFrom)
  const diff = {}

  diff.years = date2.getFullYear() - date1.getFullYear()
  diff.months = date2.getMonth() - date1.getMonth()
  diff.days = date2.getDate() - date1.getDate()

  if (diff.days < 0) {
    diff.months -= 1
    diff.days += new Date(date2.getFullYear(), date2.getMonth(), 0).getDate()
  }

  if (diff.months < 0) {
    diff.years -= 1
    diff.months += 12
  }

  if (!!diff.years) {
    return `${diff.years} year${isPlural(diff.years)} ago`
  }
  if (!!diff.months) {
    return `${diff.months} month${isPlural(diff.months)} ago`
  }
  if (!!diff.days) {
    return `${diff.days} day${isPlural(diff.days)} ago`
  }

  return 'Today'
}

const convertMillisecondsToSeconds = milliseconds => {
  const seconds = milliseconds / 1000
  return Number(seconds.toFixed(1))
}

const formatLastUpdated = dateString => {
  if (!dateString) return null
  const date = new Date(dateString)
  const now = new Date()
  const diffMs = now - date
  const diffMins = Math.floor(diffMs / 60000)
  const diffHours = Math.floor(diffMs / 3600000)
  const diffDays = Math.floor(diffMs / 86400000)

  if (diffMins < 1) return 'Just now'
  if (diffMins < 60) return `${diffMins} minute${isPlural(diffMins)} ago`
  if (diffHours < 24) return `${diffHours} hour${isPlural(diffHours)} ago`
  if (diffDays < 3) return `${diffDays} day${isPlural(diffDays)} ago`

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  })
}

export { isPlural, handleActivity, convertMillisecondsToSeconds, formatLastUpdated }
